import Resource from './Resource';

class CustomerLanguage extends Resource {
	constructor() {
		super('language');
	}
}

const resource = new CustomerLanguage();

export default resource;
